import Vue from 'vue'
import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '559266610996-mbq4vopflkmua4eir6o54o63g4tmrvas.apps.googleusercontent.com',
    scope: 'email profile https://www.googleapis.com/auth/contacts https://www.googleapis.com/auth/calendar.events',
    prompt: 'consent',
    fetch_basic_profile: false
}
Vue.use(GAuth, gauthOption)